import { setCookie, getCookie } from './cookies.js';
import { o as COOKIE_AC_EMAIL } from '../cookies-l-jEMp6P.js';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-a4IKjS7g.js';
import 'cookies-next';
import './isBot.js';

const getSubscriberKey = (catalogId, email) => `${catalogId.toLowerCase()}_${email}`;
const setOrganizationId = () => {
    try {
        _etmc.push(['setOrgId', process.env.NEXT_PUBLIC_SF_MID]);
        _etmc.push(['trackPageView']);
        // eslint-disable-next-line no-empty
    }
    catch (error) { }
};
const setUserInformation = (catalogId, email) => {
    try {
        setCookie(COOKIE_AC_EMAIL, email);
        const subscriberKey = getSubscriberKey(catalogId, email);
        _etmc.user_info = undefined;
        _etmc.push([
            'setUserInfo',
            {
                email: subscriberKey,
            },
        ]);
        // eslint-disable-next-line no-empty
    }
    catch (error) { }
};
const setUserCart = (cartPayload) => {
    try {
        const abandonedCartEmail = getCookie(COOKIE_AC_EMAIL);
        if (!abandonedCartEmail)
            return;
        const cartItems = cartPayload.items;
        if (cartItems.length === 0) {
            _etmc.push(['trackCart', { clear_cart: true }]);
            return;
        }
        const cart = cartItems.map(({ product: { sku }, quantity, prices: { price: { value: itemPrice }, total_item_discount: { value: itemDiscount }, }, }) => ({
            item: sku,
            quantity,
            price: itemPrice,
            sale_price: itemPrice - itemDiscount,
            unique_id: sku,
        }));
        _etmc.push([
            'trackCart',
            {
                cart,
            },
        ]);
        // eslint-disable-next-line no-empty
    }
    catch (error) { }
};
const setTrack = (catalogId) => {
    try {
        _etmc.tracking_disabled = false;
        _etmc.push(['setOrgId', process.env.NEXT_PUBLIC_SF_MID]);
        _etmc.push(['trackPageView']);
        const abandonedCartEmail = getCookie(COOKIE_AC_EMAIL);
        if (abandonedCartEmail) {
            const subscriberKey = getSubscriberKey(catalogId, abandonedCartEmail);
            _etmc.push([
                'setUserInfo',
                {
                    email: subscriberKey,
                },
            ]);
        }
        // eslint-disable-next-line no-empty
    }
    catch (error) { }
};
const setDoNotTrack = () => {
    try {
        _etmc.push(['setOrgId', '123456']);
        _etmc.push(['doNotTrack']);
        _etmc.push(['trackPageView']);
        // eslint-disable-next-line no-empty
    }
    catch (error) { }
};
const trackConversion = (cartPayload) => {
    try {
        const cartItems = cartPayload.items;
        const cart = cartItems.map(({ product: { sku }, quantity, prices: { price: { value: itemPrice }, total_item_discount: { value: itemDiscount }, }, }) => ({
            item: sku,
            quantity,
            price: itemPrice,
            sale_price: itemPrice - itemDiscount,
            unique_id: sku,
        }));
        _etmc.push(['trackConversion', { cart }]);
        _etmc.push(['trackCart', { clear_cart: true }]);
        // eslint-disable-next-line no-empty
    }
    catch (error) { }
};

export { setDoNotTrack, setOrganizationId, setTrack, setUserCart, setUserInformation, trackConversion };
//# sourceMappingURL=salesforce.js.map
